import Safety from './safety'
import SafetyOther from './safetyOther'
import Exposure from './exposure'
import Trailering from './trailering'
import Accidents from './accidents'
import Ownership from './ownership'
import ParticipationPerson from './participationPerson'

const pages = [
  Exposure,
  Ownership,
  Safety,
  SafetyOther,
  Trailering,
  Accidents,
  ParticipationPerson
]

export default pages
